import { PLAN_TIER } from '@app/constant/plan-tier';
import { UNLIMITED_TRANSFER_LIMIT, GB } from '@app/constant/sizes';

export function userHasPlusTier(user) {
  return user.planTier === PLAN_TIER.PLUS;
}

export function userHasFreeTier(user) {
  return user.planTier === PLAN_TIER.FREE;
}

export function userHasFreeTierAffluent(user) {
  // HigherAffluent variant will have 2.5GB transfer size
  // where the default free tier user will have 2GB transfer size.
  const transferLimit = 2.5 * GB;
  return (
    user.planTier === PLAN_TIER.FREE &&
    user.rules.transferLimit === transferLimit
  );
}

export function isLoggedInPlusUser(user) {
  return user.loggedIn && userHasPlusTier(user);
}

export function isLoggedInFreeUser(user) {
  return user.loggedIn && userHasFreeTier(user);
}

export function isLoggedInWithUnlimitedTransfer(user) {
  return user.loggedIn && user.rules.transferLimit === UNLIMITED_TRANSFER_LIMIT;
}
